import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
	iconArrow: {
		filter: 'invert(100%)',
		height: '40px',
		cursor: 'pointer',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.complex,
			easing: theme.transitions.easing.easeIn,
		}),
		marginTop: '20px',
		'&:hover ': {
			transform: 'scale(1.5)',
		},
	},
	iconClick: {
		filter: 'invert(100%)',
		height: '40px',
		cursor: 'pointer',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.complex,
			easing: theme.transitions.easing.easeIn,
		}),
		transform: 'rotate(180deg)',
		marginTop: '20px',
		'&:hover ': {
			transform: 'scale(1.5) rotate(180deg)',
			
		},
	},
	projectCard: {
		maxWidth: '500px',
		marginTop: '40px',
		
	},
	titleProject:{
		marginTop: '40px'
	},
	mainProject:{
		fontFamily: 'Ubuntu'
	},

	root: {
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'black'
	},
	content: {
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'wrap'
	}
}));
